import React from "react";
import ReactDOM from "react-dom/client";
import "./scss/wfm.scss";

const WorkflowApp = React.lazy(() => import("./ts/WorkflowApp"));

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <WorkflowApp />
  </React.StrictMode>
);
